import React, { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import 'regenerator-runtime/runtime';
import 'react-circular-progressbar/dist/styles.css';
import 'react-loading-skeleton/dist/skeleton.css';
import '@/lib/polyfill';
import '@/lib/maplibre';
import { LoadComponent } from '@components/lazy-loader';
import App from '@/app';
import { setupChunkErrorRecovery } from '@/lib/chunk-error-recovery';
import { seedSessionFromHash } from '@/lib/seedSessionFromHash';

setupChunkErrorRecovery();
function AppWithCallbackAfterRender() {
  useEffect(() => {
    window.retracedPageLoaded = true;
  }, []);

  return (
    <StrictMode>
      <React.Suspense fallback={<LoadComponent />}>
        <App />
      </React.Suspense>
    </StrictMode>
  );
}
const container = document.getElementById('root');
const root = createRoot(container);

// Adopt a session handed over from frontend-v2 (`#token=…`) before the first
// render, so an already-authenticated user is never shown the login screen for
// a frame. Resolves immediately when there is no hash to consume, and never
// rejects — see seedSessionFromHash.
seedSessionFromHash().finally(() => {
  root.render(<AppWithCallbackAfterRender />);
});
